import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { IdentityProviderDetailsReferenceData } from "@idw-types/state/identity-provider-details-state";
import { handleRequest } from "@utils/http-util";

export const getIdentityProviderDetailsReferenceDataRequest = async (): Promise<{ data: IdentityProviderDetailsReferenceData, error: any }> => {
    const route = apiRoutes.idpConfiguration.identityProviderConfig.details.referenceData;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};